var sameArray = function sameArray(a, b) {
  if (!(a !== null && a !== void 0 && a.length)) {
    return !(b !== null && b !== void 0 && b.length);
  }
  if (a == b) {
    return true;
  }
  if (a.length !== (b === null || b === void 0 ? void 0 : b.length)) {
    return false;
  }
  return a.every(function (val, index) {
    return val === b[index];
  });
};

export { sameArray };
//# sourceMappingURL=same-array.esm.js.map
